<template>
  <div>
    <p style="padding-bottom: 20px;margin-bottom: 0">客户名称：{{company}}</p>
    <a-tabs type="card" @change="callback"  :default-active-key="activeKey?'2':'1'">
    <a-tab-pane key=1 tab="积分明细" >
      <Details :key="ListKey* Math.random()" />
    </a-tab-pane>
    <a-tab-pane key=2 tab="兑换记录">
      <Record :key="ListKey* Math.random()" />
    </a-tab-pane>

  </a-tabs></div>
</template>

<script>
import Details from "./details"
import Record from "./record"
export default {
  name: "CustomerPointsDetails",
  data(){
    return{
      activeKey:this.$route.query.type,
      company:this.$store.state.company,
      ListKey:""
    }
  },
  watch:{
    '$store.state.company': 'getCompany'
  },
  created() {
    this.$store.state.adminleftnavnum = "/CustomerPoints/CustomerPointsList"; //设置左侧导航2-2 active
  },
  methods:{
    getCompany(){
      this.company=this.$store.state.company
    },
    callback (){
      this.ListKey = new Date().getTime() * Math.random();
}
  },
  components:{Details,Record}
}
</script>

<style scoped>

</style>
